/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";
import type { ProductOption } from "./ProductOption";
import type { VisitType } from "./VisitType";

export interface RxAgentMetadata {
  /** Optional partner intent to be provided from FE local storage. */
  partner_intent?: PartnerIntentRequest | null;
  /** Deprecated: send clinic_request_id on the request root instead. */
  clinic_request_id?: string | null;
  /** Product selected before entering the progression */
  payment_product_option?: ProductOption | null;
  /** Async visit modality fixed by the clinic request */
  payment_visit_type?: VisitType | null;
}
